module.exports = __webpack_public_path__ + "assets/compensation.4035d56a.svg";